export const FeatureName = 'federationDetail';
